import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var AngleDown = function AngleDown(props) {
  useDeprecatedComponentWarning({
    component: 'AngleDown'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 512"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
  }));
};

AngleDown.displayName = 'AngleDown';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  AngleDown.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default AngleDown;